export default __webpack_public_path__ + "static/media/advert-blue-2.7c884a49.png";